import { SystemStyleObject } from '@chakra-ui/react';

interface AudioPlayerTrackSx {
  audioTrack: SystemStyleObject;
  error: SystemStyleObject;
}

interface AudioPlayerTrackSxProps {
  isLoading: boolean;
}

export const audioPlayerTrackSx: (
  props: AudioPlayerTrackSxProps
) => AudioPlayerTrackSx = ({ isLoading }) => ({
  audioTrack: {
    cursor: 'pointer',
    gridArea: 'track',
    display: 'block',
    zIndex: 1,
    width: 'full',
    minH: 6,
    position: 'relative',
    '&#audio-track-container ::part(wrapper)': {
      opacity: isLoading ? 0 : 1,
      transition: 'opacity 0.15s',
    },
    '&#audio-track-container ::part(canvases)': {
      mt: 0,
    },
    '&#audio-track-container ::part(cursor)': {
      display: 'none',
    },
    '&#audio-track-container ::part(hover)': {
      display: 'none',
    },
    '&#audio-track-container ::part(scroll)': {
      overflow: 'visible',
    },
  },
  error: {
    position: 'absolute',
    top: '50%',
    right: '50%',
    transform: 'translate(50%, -50%)',
    px: 2,
    bg: 'surface1',
    color: 'textSubdued',
    zIndex: 'popover',
    width: '100%',
    maxWidth: '250px',
  },
});
